import React, { useEffect, useState, useRef } from "react";
import AdminHeader from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import { useForm} from "react-hook-form"
import { ApiService } from "../../component/Services/apiservices";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Badge from 'react-bootstrap/Badge';
import constant from "../../component/Services/constant";
const Customer = () => {
    const [Userdata, setUserdata] = useState([])
    const [showResetBtn, setShowRestBtn] = useState(false)
    const [Query, setQuery] = useState('')
    const [ChoosePropertyStatus, seChoosePropertyStatus] = useState('0')
    const navigate = useNavigate()
    let apiServices = new ApiService();
    const didMountRef = useRef(true)
    const {
        formState: { errors }
    } = useForm();
    useEffect(() => {

        if (didMountRef.current) {
            getalluserlist()
        }
        didMountRef.current = false;
    }, [])

    const getalluserlist = (propertystaus='0') => {
        let dataString={
            propertytrackStaus:Number(propertystaus)
        }
       ApiService.postData('admin/getuserlistdata' , dataString).then(res => {
            if (res?.status === "success") {
                setUserdata(res?.UserData)
            }
        }).catch((error) => { })
    }

    const handlesearchSubmit = () => {
        if (Query.length > 2) {
            const dataString={
                propertytrackStaus:Number(ChoosePropertyStatus)
            }
            ApiService.postData(`admin/getusersearchlistdata?searchQuery=${Query}` , dataString ).then((res) => {
                if (res?.status == "success") {
                    setUserdata(res.UserData)
                    setShowRestBtn(true)
                }
                else {
                    toast.error(res.message)
                }
            }).catch((error) => { })
        }
    }

    const changestatus = (data) => {
        const requestBody = {
            user_id: data._id
        };
        ApiService.postData('/admin/changeuserstatus', requestBody).then(res => {
            if (res.status === "success") {
                getalluserlist()
            }
            else {
                toast.error(res.data.message)
            }
        }).catch(error => {
            console.error('Error submitting form:', error);
            // Handle error
        });
    }
    const onResetclick = () => {
        seChoosePropertyStatus('0')
        setQuery('')
        getalluserlist()
        setTimeout(() => {
            setShowRestBtn(false)
        }, 2000)
    }

   const  changePropertyStatus=(e)=>{
    setQuery('')
    setShowRestBtn(false)
    seChoosePropertyStatus(e.target.value)
    getalluserlist(e.target.value)
    }

    return (<>
        <ToastContainer />
        <div id="layout-wrapper">
            <AdminHeader />
            <Sidebar />
            <div class="main-content">
                <div class="page-content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <div>
                                        <h4 class="mb-sm-0">Manage Customers</h4>
                                        <ol class="breadcrumb mt-2">
                                            <li class="breadcrumb-item"><a href="/csadmin/dashboard">Dashboard</a></li>
                                            <li class="breadcrumb-item active">Manage Customers</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card">

                                    <div class="card-body">
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-lg" placeholder="Search" aria-label="Example text with two button addons" value={Query} onChange={(e) => { setQuery(e.target.value); setShowRestBtn(false) }} />
                                            <button class="btn btn-primary" type="button" onClick={() => { handlesearchSubmit() }}>Search</button>
                                            {showResetBtn ? <>
                                                <button class="btn btn-success" type="button" onClick={() => { onResetclick() }}>Reset</button>
                                            </> : ''}

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card">
                                <div className="d-flex justify-content-end p-3 pb-0 ">
                                <select onChange={(e)=>{changePropertyStatus(e)}} class="btn btn-primary" value={ChoosePropertyStatus}>
                                    <option value='1'>Track Properties</option>
                                    <option value='0'>My Properties</option>
                                </select>
                            </div>
                            <hr></hr>
                                    <div class="card-body">
                                        <div class="live-preview">
                                            {Userdata && Userdata.length > 0 ? <>

                                                <table class="table table-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">S.No</th>
                                                            <th scope="col">Customer Name</th>
                                                            <th scope="col">Mobile</th>
                                                            <th scope="col">Email</th>
                                                            <th scope="col">Total Properties</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Registration Date</th>
                                                            <th scope="col">Action</th>


                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {Userdata?.map((items, index) => {
                                                            return (<>

                                                                <tr>
                                                                    <td class="fw-semibold">{index + 1}</td>
                                                                    <td>{items.user_name}</td>
                                                                    <td>{items.user_mobileno}</td>
                                                                    <td>{items.user_email}</td>
                                                                    <td>{items.property_count}</td>
                                                                    <td >{items?.user_admin_status == 0 ?
                                                                        <Badge bg="danger" onClick={() => { changestatus(items) }}>Inactive</Badge> : items.user_admin_status == 1 ? <Badge bg="success" onClick={() => { changestatus(items) }}>Active</Badge> : ''}</td>
                                                                    <td>{moment(items?.created_at).format(`LL`)}</td>
                                                                    <td className="  fs-5"> <i className="text-warning mdi mdi-lead-pencil" onClick={() => { navigate(`/csadmin/customer/${items._id}`) }}></i>   </td>


                                                                </tr>
                                                            </>)
                                                        })}


                                                    </tbody>
                                                </table>
                                            </> : <><h6 className="text-center">No User Found</h6></>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div >

        </div >


    </>)
}
export default Customer